import {Accordion, Breakpoints} from '@shopify/marketing-assets';
import '../../application';

document.addEventListener('DOMContentLoaded', () => {
  new Accordion(document.getElementById('pricingFaq'), {
    openFirst: false,
  });
  pricingTable();
});

function pricingTable() {
  if (matchMedia) {
    const isMobile = window.matchMedia(Breakpoints.prototype.phone);
    isMobile.addListener(mobileHandlers);
    mobileHandlers(isMobile);
  }

  const planSwitchers = document.querySelectorAll('.plan-tabs__tab, .plan-arrow');
  [...planSwitchers].forEach((element) => {
    element.addEventListener('click', _onPlanControlClick, false);
  });
}

function mobileHandlers(mediaQuery) {
  toggleHeaderColSpan(mediaQuery);
  goToPlan(1);
}

function toggleHeaderColSpan(mediaQuery) {
  const tableHeaders = document.querySelectorAll('thead th');
  [...tableHeaders].forEach((th) => {
    if (mediaQuery.matches) {
      th.setAttribute('colspan', '2');
    } else {
      th.removeAttribute('colspan');
    }
  });
}

function goToPlan(planIndex) {
  const table = document.getElementById('pricingTable');
  const inactiveCells = document.querySelectorAll('[headers*="p-"], [id*="p-"]');
  const activeCells = table.querySelectorAll(`[headers*="p-${planIndex}"], #p-${planIndex}`);
  [...inactiveCells].forEach((cell) => {
    cell.classList.add('js-is-hidden');
  });
  [...activeCells].forEach((cell) => {
    cell.classList.remove('js-is-hidden');
  });
  updatePlanControlState(planIndex);
}

function updatePlanControlState(planIndex) {
  const planTabs = document.querySelectorAll('.plan-tabs__tab');
  const nextPlanIndex = parseInt(planIndex, 10) + 1 < planTabs.length ? parseInt(planIndex, 10) + 1 : 0;
  const prevPlanIndex = parseInt(planIndex, 10) - 1 >= 0 ? parseInt(planIndex, 10) - 1 : planTabs.length - 1;
  const nextArrowLabel = document.querySelector(`[data-target-index="${nextPlanIndex}"]`).dataset.planName;
  const prevArrowLabel = document.querySelector(`[data-target-index="${prevPlanIndex}"]`).dataset.planName;

  // Tabs
  [...planTabs].forEach((tab) => {
    tab.classList.remove('js-is-active');
    tab.setAttribute('aria-pressed', false);
  });
  planTabs[planIndex].classList.add('js-is-active');
  planTabs[planIndex].setAttribute('aria-pressed', true);

  // Arrows
  document.getElementById('nextPlan').innerHTML = nextArrowLabel;
  document.getElementById('prevPlan').innerHTML = prevArrowLabel;
  document.querySelector('.plan-arrow--next').setAttribute('data-target-index', nextPlanIndex);
  document.querySelector('.plan-arrow--prev').setAttribute('data-target-index', prevPlanIndex);
}

function _onPlanControlClick(evt) {
  const targetPlanId = evt.currentTarget.dataset.targetIndex;
  goToPlan(targetPlanId);
  smoothScrolling();
}

function smoothScrolling() {
  const planArrows = document.querySelector('.plan-arrows');
  planArrows.addEventListener('click', (evt) => {
    evt.preventDefault();
    const targetAnchor = document.getElementById('pricingTableAnchor');
    targetAnchor.scrollIntoView({
      behavior: 'smooth',
    });
  }, false);
}
